import { isSignatureValue } from "./signature-path.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/SignaturePad/SignatureDisplay.tsx
/**
* Renders a stored signature value as inline SVG.
*
* Vector rather than a raster keeps the stored value ~1 KB with no upload, and
* scales crisply at any size. `stroke="currentColor"` means the ink follows the
* host theme.
*
* Note: PDF export is generated server-side by a separate implementation, so it
* does not pick this component up — see
* `docs/FormBuilder-signature-field-contract.md`, which is the spec that
* renderer implements against.
*/
var SignatureDisplay = ({ className, scale = 1, value }) => {
	if (!value || typeof value !== "object") return null;
	const candidate = value;
	if (!candidate.d && candidate.url) return /* @__PURE__ */ jsx("img", {
		alt: "Signature",
		className,
		src: candidate.url
	});
	if (!isSignatureValue(value)) return null;
	if (!value.d) return null;
	return /* @__PURE__ */ jsxs("svg", {
		className,
		height: value.h,
		preserveAspectRatio: "xMidYMid meet",
		role: "img",
		style: {
			aspectRatio: `${value.w} / ${value.h}`,
			height: "auto",
			maxWidth: `${value.w * scale}px`,
			width: "100%"
		},
		viewBox: `0 0 ${value.w} ${value.h}`,
		width: value.w,
		children: [/* @__PURE__ */ jsx("title", { children: "Signature" }), /* @__PURE__ */ jsx("path", {
			d: value.d,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2"
		})]
	});
};
//#endregion
export { SignatureDisplay };

//# sourceMappingURL=SignatureDisplay.js.map